(() => {
  const script = document.currentScript;
  const historyKey = 'mishop:recommendation-history:v2';
  const ttlMs = 30 * 24 * 60 * 60 * 1000;
  const maxSearches = 12;
  const maxProducts = 20;
  const minimumProductDwellMs = 10000;

  function cleanText(value, maxLength = 120) {
    return String(value || '').trim().replace(/\s+/g, ' ').slice(0, maxLength);
  }

  function loadHistory() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(historyKey) || '{}');
      const cutoff = Date.now() - ttlMs;
      return {
        searches: Array.isArray(parsed.searches) ? parsed.searches.filter((item) => item?.term && item.at >= cutoff).slice(0, maxSearches) : [],
        products: Array.isArray(parsed.products) ? parsed.products.filter((item) => item?.title && item.at >= cutoff).slice(0, maxProducts) : []
      };
    } catch (_error) {
      return { searches: [], products: [] };
    }
  }

  function saveHistory(history) {
    try {
      window.localStorage.setItem(historyKey, JSON.stringify(history));
    } catch (_error) {
      // Storage can be blocked in private browsing.
    }
  }

  function rememberSearch(value) {
    const term = cleanText(value, 80);
    if (!term) return;
    const history = loadHistory();
    history.searches = [{ term, at: Date.now() }, ...history.searches.filter((item) => item.term.toLocaleLowerCase() !== term.toLocaleLowerCase())].slice(0, maxSearches);
    saveHistory(history);
  }

  function rememberProduct(title, url) {
    const cleanTitle = cleanText(title);
    const cleanUrl = cleanText(url, 240);
    if (!cleanTitle) return;
    const history = loadHistory();
    history.products = [{ title: cleanTitle, url: cleanUrl, at: Date.now() }, ...history.products.filter((item) => item.title !== cleanTitle)].slice(0, maxProducts);
    saveHistory(history);
  }

  rememberSearch(script?.dataset.searchTerm);

  const productTitle = script?.dataset.productTitle;
  if (productTitle) {
    window.setTimeout(() => {
      if (document.visibilityState === 'visible') rememberProduct(productTitle, script?.dataset.productUrl);
    }, minimumProductDwellMs);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[name="q"]');
    if (input) rememberSearch(input.value);
  });
})();
